import { Button, IconButton } from "@mui/material";
import React from "react";
import LoadingIcon from "@mui/icons-material/HourglassEmpty";

import Tooltip from "../Tooltip/Tooltip";
import { ButtonPropTypes } from "./buttonPropsTypes";
import injectStores from "components/RootStore/injectStores";

// import type ViewStore from 'stores/ViewStore';

export type ButtonProps = ButtonPropTypes & {
  /** A click handler */
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  extraButtonSX?: object;
};

// class ButtonComponent extends React.PureComponent<ButtonProps> {
//   static defaultProps = {
//     color: 'gray' as 'gray', // Explicitly type color
//     simple: false,
//     round: false,
//     fullWidth: false,
//     disabled: false,
//     block: false,
//     link: false,
//     justIcon: false,
//     loading: false,
//     autosize: false,
//     tooltipPlacement: 'bottom' as 'bottom', // Explicitly type tooltipPlacement
//   };

//   render() {
//     const {
//       children,
//       disabled,
//       justIcon,
//       classes,
//       size,
//       color,
//       round,
//       fullWidth,
//       simple,
//       block,
//       link,
//       loading,
//       onClick,
//       tooltip,
//       tooltipPlacement,
//       autosize,
//     } = this.props;

//     let buttonDisabled = disabled;
//     let renderer = children;
//     let buttonColor = color;
//     let buttonSize = size;

//     if (autosize ) {
//       if (isMobile) {
//         buttonSize = 'sm';
//       } else {
//         buttonSize = undefined;
//       }
//     }

//     if (loading) {
//       buttonDisabled = true;
//       renderer = justIcon ? <LoadingIcon /> : 'Loading…';
//     }

//     if (buttonDisabled) {
//       buttonColor = 'gray';
//     }

//     const btnClasses = clsx({
//       [classes.button]: true,
//       [buttonSize ? classes[String(buttonSize)] : '']: buttonSize,
//       // @ts-ignore
//       [typeof buttonColor === 'string' && buttonColor !== ''
//         ? classes[buttonColor]
//         : undefined]: buttonColor || undefined, // Add a check for buttonColor before using it as an index
//       [classes.round]: round,
//       [classes.fullWidth]: fullWidth,
//       [classes.disabled]: buttonDisabled,
//       [classes.simple]: simple, //TODO: deprecate
//       [classes.block]: block, //TODO: deprecate
//       [classes.link]: link, //TODO: deprecate
//       [classes.justIcon]: justIcon,
//     });

//     if (tooltip) {
//       if (tooltip && buttonDisabled) {
//         return (
//           <Tooltip title={tooltip} placement={tooltipPlacement}>
//             <span style={{ margin: 0, padding: 0 }}>
//               <MUIButton
//                 className={btnClasses}
//                 variant="contained"
//                 // disabled={buttonDisabled}
//                 onClick={(e) => {
//                   if (!buttonDisabled) onClick(e);
//                 }}
//               >
//                 {renderer}
//               </MUIButton>
//             </span>
//           </Tooltip>
//         );
//       }
//       return (
//         <Tooltip title={tooltip} placement={tooltipPlacement}>
//           <MUIButton
//             className={btnClasses}
//             variant="contained"
//             // disabled={buttonDisabled}
//             onClick={(e) => {
//               if (!buttonDisabled) onClick(e);
//             }}
//           >
//             {renderer}
//           </MUIButton>
//         </Tooltip>
//       );
//     }
//     return (
//       <MUIButton
//         className={btnClasses}
//         variant="contained"
//         // disabled={buttonDisabled}
//         onClick={(e) => {
//           if (!buttonDisabled) onClick(e);
//         }}
//       >
//         {renderer}
//       </MUIButton>
//     );
//   }
// }

// const Button = withStyles(buttonStyle)(injectStores(ButtonComponent));

// class Button extends React.PureComponent {
//   render() {
//     const { children } = this.props;
//     return <MUIButton>{children}</MUIButton>;
//   }
// }

const BaseButton = injectStores(
  ({
    variant = "contained",
    children,
    onClick,
    disabled,
    loading,
    tooltip,
    fullWidth,
    justIcon = false,
    iconButton = false,
    color,
    size = "medium",
    autosize,
    autosizeIcon,
    autosizeIconRight = false,
    viewStore,
    extraButtonSX,
  }: ButtonProps) => {
    let buttonDisabled = disabled;

    const isMobile = viewStore?.isMobile ?? false;
    if (loading) {
      buttonDisabled = true;
      if (justIcon) {
        children = <LoadingIcon />;
      } else {
        children = "Loading…";
      }
    }

    if (color === "transparent") {
      color = "gray";
      variant = "text";
    }
    // console.log('autosize', autosize);
    // console.log('isMobile', isMobile);
    if (autosize && isMobile) {
      // console.log('trigger autosize');
      size = "small";
    }

    const justAutosizeIcon = autosize && !!autosizeIcon && isMobile;

    // Helper function to render icon and children
    const renderIconAndChildren = () => {
      if (autosizeIcon && children) {
        if (justAutosizeIcon) {
          return autosizeIcon;
        } else if (autosizeIconRight) {
          return (
            <>
              <div style={{ paddingTop: "3px" }}>{children}</div> {autosizeIcon}
            </>
          );
        } else {
          return (
            <>
              {autosizeIcon} <div style={{ paddingTop: "3px" }}>{children}</div>
            </>
          );
        }
      }
      return children;
    };

    const buttonSX =
      justIcon || justAutosizeIcon
        ? {
            height: size === "small" ? "31px" : "41px",
            width: size === "small" ? "31px" : "41px",
            minWidth: size === "small" ? "31px" : "41px",
            paddingLeft: "12px",
            paddingRight: "12px",
            marginLeft: "2px",
            marginRight: "2px",
            ...extraButtonSX,
          }
        : {
            height: size === "small" ? "31px" : "41px",
            marginLeft: "2px",
            marginRight: "2px",
            ...extraButtonSX,
          };

    if (tooltip) {
      if (iconButton) {
        const iconButtonElement = (
          <IconButton
            size={size}
            disabled={buttonDisabled}
            color={buttonDisabled ? "gray" : color}
            onClick={(e) => {
              if (!buttonDisabled) onClick(e);
            }}
            sx={extraButtonSX}
          >
            {children}
          </IconButton>
        );

        return (
          <Tooltip title={tooltip} placement="bottom">
            {buttonDisabled ? <span>{iconButtonElement}</span> : iconButtonElement}
          </Tooltip>
        );
      }

      const buttonElement = (
        <Button
          sx={buttonSX}
          size={size}
          fullWidth={fullWidth}
          variant={variant}
          disabled={buttonDisabled}
          color={buttonDisabled ? "gray" : color}
          onClick={(e) => {
            if (!buttonDisabled) onClick(e);
          }}
        >
          {renderIconAndChildren()}
        </Button>
      );

      return (
        <Tooltip title={tooltip} placement="bottom">
          {buttonDisabled ? <span style={{ display: 'inline-block' }}>{buttonElement}</span> : buttonElement}
        </Tooltip>
      );
    }

    if (iconButton) {
      return (
        <IconButton
          sx={extraButtonSX}
          size={size}
          disabled={buttonDisabled}
          color={buttonDisabled ? "gray" : color}
          onClick={(e) => {
            if (!buttonDisabled) onClick(e);
          }}
        >
          {children}
        </IconButton>
      );
    }

    return (
      <Button
        sx={buttonSX}
        size={size}
        fullWidth={fullWidth}
        variant={variant}
        disabled={buttonDisabled}
        color={buttonDisabled ? "gray" : color}
        onClick={(e) => {
          if (!buttonDisabled) onClick(e);
        }}
      >
        {renderIconAndChildren()}
      </Button>
    );
  }
);

export default BaseButton;
